const LUXURY_AUDIO_STATIC_FRAME = 0;

class LuxuryAudioPlayer {
  constructor() {
    this.toggleBtn = document.getElementById('ambient-sound-toggle');
    this.audio = document.getElementById('luxury-audio');
    this.containerW = document.getElementById('lottie-sound-w');
    this.containerB = document.getElementById('lottie-sound-b');

    this.isPlaying = false;
    this.animW = null;
    this.animB = null;

    if (!this.toggleBtn || !this.audio || !this.containerW || !this.containerB) return;

    this.init();
  }

  init() {
    // Wait for Lottie library to load
    const waitLottie = setInterval(() => {
      if (typeof lottie !== 'undefined') {
        clearInterval(waitLottie);
        this.loadAnimations();
        this.bindEvents();
      }
    }, 100);

    // Safety: stop waiting after 10s
    setTimeout(() => clearInterval(waitLottie), 10000);
  }

  loadAnimations() {
    const animDataW = window.theme_asset_urls?.ambientSoundToggleW || '/cdn/shop/assets/ambient-sound-toggle-w.json';
    const animDataB = window.theme_asset_urls?.ambientSoundToggleB || '/cdn/shop/assets/ambient-sound-toggle-b.json';

    this.animW = lottie.loadAnimation({
      container: this.containerW,
      renderer: 'svg',
      loop: true,
      autoplay: false,
      path: animDataW
    });

    this.animB = lottie.loadAnimation({
      container: this.containerB,
      renderer: 'svg',
      loop: true,
      autoplay: false,
      path: animDataB
    });

    const syncWhenReady = (anim) => {
      if (anim.isLoaded) {
        this.syncAnimationState();
      } else {
        anim.addEventListener('DOMLoaded', () => this.syncAnimationState());
      }
    };

    this.applyInitialState();
    syncWhenReady(this.animW);
    syncWhenReady(this.animB);
  }

  bindEvents() {
    this.toggleBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.toggleAudio();
    });
  }

  applyInitialState() {
    this.isPlaying = false;
    localStorage.setItem('luxury-audio-playing', 'false');
    this.playToState('paused');
  }

  toggleAudio() {
    if (this.isPlaying) {
      this.audio.pause();
      this.isPlaying = false;
      this.playToState('paused');
      localStorage.setItem('luxury-audio-playing', 'false');
    } else {
      this.audio.play().then(() => {
        this.isPlaying = true;
        this.playToState('playing');
        localStorage.setItem('luxury-audio-playing', 'true');
      }).catch(e => {
        this.isPlaying = false;
        this.playToState('paused');
        localStorage.setItem('luxury-audio-playing', 'false');
        console.log('Audio play failed:', e);
      });
    }
  }

  syncAnimationState() {
    this.playToState(this.isPlaying ? 'playing' : 'paused');
  }

  playToState(state) {
    if (state === 'playing') {
      this.toggleBtn.classList.remove('is-paused');
      if (this.animW) { this.animW.play(); }
      if (this.animB) { this.animB.play(); }
    } else {
      this.toggleBtn.classList.add('is-paused');
      if (this.animW) { this.animW.goToAndStop(LUXURY_AUDIO_STATIC_FRAME, true); }
      if (this.animB) { this.animB.goToAndStop(LUXURY_AUDIO_STATIC_FRAME, true); }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new LuxuryAudioPlayer();
});
